import { Component, OnInit } from '@angular/core';
import { ClientServiceService } from '../services/client-service.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit{

  blogs: any = [];

  currentPage: number = 1;
  pageSize: number = 6;
  totalPages: number = 0;

  constructor(
    private client_service: ClientServiceService,
    public translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.get_all_blogs();
  }

  get_all_blogs() {
    this.client_service.get_blogs(this.currentPage, this.pageSize).subscribe({
      next: (data) => {
        this.blogs = data.items;
        this.totalPages = data.total_pages;
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  handleImageError(blog: any): void {
    blog.url_img = 'assets/img/bg2.png';
  }

  nextPage(event: Event): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      this.get_all_blogs();
      const button = event.currentTarget as HTMLElement;
      button.blur();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  previousPage(event: Event): void {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.get_all_blogs();
      const button = event.currentTarget as HTMLElement;
      button.blur();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
